import { render, staticRenderFns } from "./accomodationList.vue?vue&type=template&id=c18e7dec&scoped=true&"
import script from "./accomodationList.vue?vue&type=script&lang=js&"
export * from "./accomodationList.vue?vue&type=script&lang=js&"
import style0 from "./accomodationList.vue?vue&type=style&index=0&id=c18e7dec&prod&scoped=true&lang=css&"
import style1 from "./accomodationList.vue?vue&type=style&index=1&id=c18e7dec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18e7dec",
  null
  
)

export default component.exports